import { useAppSelector } from 'slices/commonSelectors';

type AuthState = {
  type?: string;
  teamsInitialized?: boolean;
};

export const useIsEntraCapable = (): boolean => {
  // state.auth is a JS reducer with an untyped runtime shape ({ type, teamsInitialized, ... } from index.tsx).
  // Cast at the selector boundary so the rest of the hook is typed.
  const auth = useAppSelector(
    (state) => (state.auth as unknown as AuthState | undefined) ?? undefined
  );
  const isTeams =
    sessionStorage.getItem('isUsingTeams') === 'true' ||
    !!auth?.teamsInitialized;
  return auth?.type === 'MSAL' || isTeams;
};
